<template>
    <div>
        <el-button type="primary" :disabled="beginning || loading" size="small" :loading="loading"
            @click="getVerifyCode">
            {{ beginning ? time + "s后重新获取" : "获取验证码" }}
        </el-button>
    </div>
</template>
<script>
import { validatePhone } from '../utils/validate'

export default {
    props: {
        phone: {
            type: String,
            default: ''
        },
        codeType: {
            type: String,
            default: '1' // 1: 注册, 2: 登录, 3: 忘记密码
        },
    },
    name: 'VerifyCode',
    data() {
        return {
            isDev: this.$store.state.IS_DEV,
            beginning: false,
            time: 60,
            loading: false,
            timer: null
        }
    },
    methods: {
        // 验证手机号格式
        validatePhoneFormat() {
            const result = validatePhone(this.phone)
            if (!result.valid) {
                this.$message.warning(result.message)
                return false
            }
            return true
        },

        // 获取验证码
        getVerifyCode() {
            // 验证手机号
            if (!this.validatePhoneFormat()) return
            // 防止重复点击
            if (this.beginning) return
            this.loading = true
            // 调用获取验证码API
            this.$api.getVerificationCode({
                mobile: this.phone,
                type: this.codeType,
                is_test: this.isDev
            }).then(res => {
                // 开始倒计时
                this.startCountdown()
                // 向用户发送提示
                if (this.isDev == '1') {
                    this.$message.success('验证码为' + res.code)
                } else {
                    this.$message.success('验证码发送成功')
                }
            }).catch(err => {
                this.$message.error(err)
            }).finally(() => {
                this.loading = false
            })
        },

        // 开始倒计时
        startCountdown() {
            this.beginning = true
            this.time = 60
            // 清除之前的计时器
            if (this.timer) {
                clearInterval(this.timer)
            }
            // 设置新的计时器
            this.timer = setInterval(() => {
                this.time--
                if (this.time <= 0) {
                    clearInterval(this.timer)
                    this.beginning = false
                    this.time = 60
                }
            }, 1000)
        }
    },
    // 组件销毁前清除计时器
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    }
}
</script>